import * as React from 'react';
import classNames from 'classnames';
import { useMediaIsDesktop } from '@collaborator/npm_modules/dist/components/media';
import { FC } from 'react';

type SvgSpriteProps = {
  id: string,
  sprite?: string,
  size?: number,
  sizeDesktop?: number,
  sizeMobile?: number,
  width?: number,
  height?: number,
  className?: string,
  additionalClassName?: string,
  additionalClassNameDesktop?: string,
  additionalClassNameMobile?: string,
  props?: {[key: string]: any},
};

const SvgSprite: FC<SvgSpriteProps> = ({
  id,
  sprite = `${process.env.BASE_URL}/builds/sprite.svg`,
  size,
  sizeDesktop,
  sizeMobile,
  width = 24,
  height = 24,
  className = 'icon',
  additionalClassName,
  additionalClassNameDesktop,
  additionalClassNameMobile,
  props = {},
}) => {
  const isDesktop = useMediaIsDesktop();

  const getCurrentSize = () => {
    if (isDesktop && sizeDesktop) {
      return sizeDesktop;
    }

    if (!isDesktop && sizeMobile) {
      return sizeMobile;
    }

    return size;
  };

  const newProps = { ...props };
  newProps.width = getCurrentSize() || width;
  newProps.height = getCurrentSize() || height;
  newProps['aria-hidden'] = true;

  return (
    <svg
      className={classNames(
        className,
        additionalClassName,
        { [additionalClassNameDesktop]: isDesktop && additionalClassNameDesktop },
        { [additionalClassNameMobile]: !isDesktop && additionalClassNameDesktop },
      )}
      {...newProps}
    >
      <use href={`${sprite}#${id}`} />
    </svg>
  );
};

export default SvgSprite;
